export function debounce(callback, delay) {
    let timer;

    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            callback(...args);
        }, delay);
    };
}

export function clearLocalStorage() {
    const language = localStorage.getItem('language') || process.env.REACT_APP_DEFAULT_LANG;
    localStorage.clear();
    localStorage.setItem('language', language);
}
